import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'


createApp(App).use(createPinia()).component('VueDatePicker', VueDatePicker).mount('#app');